import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import withAuthorization from './withAuthorization';
import {FormattedLabelsAndValues} from "../huntcomponents/FormattedLabelsAndValues";
import {updateUserName} from "../../actions";

import { auth, db } from '../../firebase';

import '../../global.css'
import './AccountPage.css'
import Modal from "react-modal";
import {ConfirmDelete} from "../huntcomponents/dialogs";
import {COMMON_DATE} from "../../constants/Strings";
import moment from "moment";
import {withRouter} from "react-router-dom";


const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
});

class AccountPage extends React.Component {

    constructor(props) {
        super(props);

        const userName = props.user ? props.user.name : "";

        this.state = {
            newUserName: userName,
            deleteAccountModalIsOpen: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onDeleteAccount = this.onDeleteAccount.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.closeDeleteModal = this.closeDeleteModal.bind(this);
    }

    onSubmit = (event) => {
        const {
            newUserName
        } = this.state;

       const {  authUser, updateUser } = this.props;

        updateUser(authUser.uid, newUserName, () => {
            this.setState( {newUserName});
        });
    };

   onDeleteClicked = (event) => {
      this.setState({deleteAccountModalIsOpen: true});
   }

   closeDeleteModal() {
      this.setState({deleteAccountModalIsOpen: false});
   }

   onDeleteAccount(event) {
      const { user, history } = this.props;

      const userId = user.id;
      const onSuccess = () => { alert("Success.  Account deleted."); };
      const onFail = (error) => {
         console.log("failed to delete: ", error);
         // We're assuming failure is that we need a re-auth.  So we're routing to /signin, with a state so
         // that it knows to route back here after successful login.
         history.push({
            pathname: '/signin',
            state: { onAccount: true }
         })
      }
      // Mark regular database user record as "deleting..."
      db.markUserDeleting(userId)
         .then(function () {
            // User deleting; remove auth
            // Attempt to delete user from auth database (managed by firebase auth system).

            auth.doDeleteUser()
               .then(onSuccess)
               .catch(onFail);
      });
   }

   render() {
      const {user, authUser} = this.props;

      let labels = [];
      let values = [];
      const displayName = user ? user.name : "";

      const date = authUser.metadata.creationTime;

      const formattedDate = moment(date).format(COMMON_DATE);

      labels.push("Username");
      values.push(displayName);
      labels.push(" Created");
      values.push(formattedDate);

      const changeUserNameText = displayName.length >= 2 ? "Change user name" : "Set user name";
      const isInvalid = this.state.newUserName.length < 2;

      return (
         <div className="main">
            <div className="mostly-opaque-white form-signin">

               <h1>Account</h1>
               <h4 className="top-margin"> {authUser.email} </h4>
               <FormattedLabelsAndValues className="small-top-margin" labels={labels} values={values}/>
               <div className="">
                  <button
                     className="btn btn-link"
                     onClick={this.onDeleteClicked}>
                          <span className="text-danger">
                              Delete Account
                          </span>
                  </button>
               </div>

               <form onSubmit={this.onSubmit}>
                  <h4 className="big-top-margin"> {changeUserNameText} </h4>
                  <input
                     type="text"
                     value={this.state.newUserName}
                     onChange={event => this.setState(byPropKey('newUserName', event.target.value))}
                     placeholder="User name"
                     className="form-control small-bottom-margin"
                  />
               </form>
               <button
                  disabled={isInvalid}
                  className="btn btn-primary top-margin big-bottom-margin center btn-block AccountPage-button-style"
                  onClick={this.onSubmit}
               >
                  Submit
               </button>

            </div>
            <div>
            </div>

            <Modal
               isOpen={this.state.deleteAccountModalIsOpen}
               onRequestClose={this.closeDeleteModal}
               className="confirm-modal-content"
               overlayClassName="my-modal-overlay"
            >
               <ConfirmDelete
                  title="Delete Account?"
                  message="Permanently delete your user account and all data?  You may need to re-login to complete deletion if you haven't done so in a while."
                  confirmText="Delete"
                  onConfirm={this.onDeleteAccount}
                  closeModalCallback={this.closeDeleteModal}
               />
            </Modal>
         </div>
      )
   }
}

const mapStateToProps = (state) => ({
    authUser: state.sessionState.authUser,
    user: state.userState.user,
});

const authCondition = (authUser) => !!authUser;

export default compose(
   withAuthorization(authCondition),
   connect(mapStateToProps, { updateUser: updateUserName }),
   withRouter
)(AccountPage);



// WEBPACK FOOTER //
// ./src/components/auth/AccountPage.js